import React from 'react';
import Calculadora from '../../../components/ui/Admin/CalculadoraComponents/Calculadora';

const CalculadoraUI = () => {
  return (
    <div className="pb-4">
      <Calculadora />
    </div>
  );
};

export default CalculadoraUI;
